(() => {
  const node = document.getElementById('mw-alpha-gift-config');
  if (!node || window.mwAlphaGift) return;
  const config = JSON.parse(node.textContent);
  const ids = new Set(config.ids.map(String));
  const root = config.root.replace(/\/$/, '') + '/';
  const active = () => config.enabled && (!config.endsAt || Date.now() < Date.parse(config.endsAt));
  const isGift = item => String(item.variant_id) === config.variant && item.properties?._mw_alpha_gift === '2026';
  let pending;
  let repeat = false;
  async function request(path, body) {
    const response = await fetch(root + path, body ? {method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify(body)} : {headers:{Accept:'application/json'}, cache:'no-store'});
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || config.error);
    return result;
  }
  async function removeMarkedGifts(cart) {
    const gifts = cart.items.filter(isGift);
    return gifts.length ? request('cart/update.js', {updates:Object.fromEntries(gifts.map(item => [item.key, 0]))}) : cart;
  }
  async function sync() {
    let cart = await request('cart.js');
    const eligibleQuantity = active() ? cart.items.reduce((n,item) => n + (ids.has(String(item.product_id)) ? item.quantity : 0), 0) : 0;
    const paidAxes = cart.items.filter(item => String(item.variant_id) === config.variant && !isGift(item)).reduce((n,item) => n + item.quantity, 0);
    const desired = Math.max(0, eligibleQuantity - paidAxes);
    const gifts = cart.items.filter(isGift);
    let changed = false;
    try {
      if (gifts.length !== (desired ? 1 : 0) || (gifts[0]?.quantity || 0) !== desired) {
        if (gifts.length) {
          cart = await removeMarkedGifts(cart);
          changed = true;
        }
        if (desired) {
          await request('cart/add.js', {items:[{id:config.variant, quantity:desired, properties:{_mw_alpha_gift:'2026'}}]});
          changed = true;
          cart = await request('cart.js');
        }
      }
      if (eligibleQuantity) {
        const axes = cart.items.filter(item => String(item.variant_id) === config.variant);
        const freeQuantity = axes.reduce((n,item) => n + (item.original_price ? ((item.original_line_price - item.final_line_price) / item.original_price) : item.quantity), 0);
        if (cart.items.some(item => isGift(item) && item.final_line_price !== 0) || freeQuantity + 0.001 < eligibleQuantity) throw new Error(config.error);
      }
    } catch (error) {
      await removeMarkedGifts(await request('cart.js'));
      document.dispatchEvent(new CustomEvent('cart:build'));
      throw error;
    }
    if (changed) document.dispatchEvent(new CustomEvent('cart:build'));
    return cart;
  }
  const reconcile = () => {
    if (pending) {
      repeat = true;
      return pending;
    }
    pending = (async () => {
      let cart;
      do {
        repeat = false;
        cart = await sync();
      } while (repeat);
      return cart;
    })().finally(() => { pending = null; });
    return pending;
  };
  window.mwAlphaGift = {eligible:id => active() && ids.has(String(id)), reconcile};
  function showError(message) {
    let error = document.getElementById('mw-alpha-gift-error');
    if (!error) {
      error = document.createElement('p'); error.id = 'mw-alpha-gift-error'; error.setAttribute('role','alert');
      error.style.cssText='background:#fff2ee;color:#8b2418;padding:16px;border:1px solid;margin:16px;';
      (document.querySelector('.cart__checkout-wrapper') || document.querySelector('main') || document.body).prepend(error);
    }
    error.textContent = message || config.error;
    error.scrollIntoView({block:'center'});
  }
  let checking = false;
  async function checkout(event, control) {
    event.preventDefault(); event.stopImmediatePropagation();
    if (checking) return;
    const form = control.closest('form');
    // Preserve the theme's required terms acceptance.
    if (form && !form.reportValidity()) return;
    if (control.dataset.termsRequired === 'true' && !form?.querySelector('.cart__terms-checkbox:checked')) {
      form?.querySelector('.cart__terms-checkbox')?.focus(); return;
    }
    checking = true; control.setAttribute('aria-busy','true');
    try {
      await reconcile();
      // Current cart quantities are already committed by the theme's Ajax cart.
      window.location.assign(root + 'checkout');
    } catch (error) {showError(error.message);checking = false;control.removeAttribute('aria-busy');}
  }
  document.addEventListener('click', event => {
    const control = event.target.closest('[name="checkout"],a[href="/checkout"],a[href$="/checkout"]');
    if (control) checkout(event, control);
  }, true);
  document.addEventListener('submit', event => {
    const control = event.submitter;
    if (control?.name === 'checkout') checkout(event, control);
  }, true);
  document.addEventListener('cart:updated', event => {
    if (active() || event.detail?.cart?.items?.some(isGift)) reconcile().catch(error => showError(error.message));
  });
  document.addEventListener('ajaxProduct:added', () => {
    if (active()) reconcile().catch(error => showError(error.message));
  });
  if (location.pathname.replace(/\/$/, '').endsWith('/cart')) {
    reconcile().then(cart => {
      // A product-page add redirects here only after reconciliation. Existing carts
      // are checked again at checkout; avoid blind reload loops and extra cart writes.
      if (new URLSearchParams(location.search).has('mw_gift_error')) showError(config.error);
    }).catch(error => showError(error.message));
  }
})();

